import React, {Fragment, useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {forgotPassword} from '../../actions/auth';

const Forgot = ({forgotPassword, forgotLoader}) => {
    const [formData, setFormData] = useState({
        email: '',
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        document.title = "Forgot-password | Prime Private Network";
    });

    const handleFromValidation = () => {
        const {email, password} = formData;
        let errors = {};
        let formIsValid = true;

        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)

        // Email Validation
        if (!email) {
            formIsValid = false;
            errors.email = "*Please Enter Your Email";
        } else if (!validEmailRegex.test(email)) {
            formIsValid = false;
            errors.email = "*Please Enter Valid Email...!";
        }


        setErrors(errors);
        return formIsValid;
    };

    const {email} = formData;

    const onChange = e =>
        setFormData({...formData, [e.target.name]: e.target.value});

    const onSubmit = e => {
        e.preventDefault();
        if (handleFromValidation()) {
            forgotPassword(email);
            setFormData({email: ''})
        }

    };

    return (
        <Fragment>
            <div className="card w-50 login-card mt-5 mx-auto">
                <h5 className="card-header">Forgot Password</h5>
                <div className="card-body">
                    <form className="form" onSubmit={onSubmit}>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" name="email" value={email}
                                   className="form-control" onChange={onChange} placeholder="Enter Your Email"/>
                            {errors.email && <span className='text-danger'>{errors.email}</span>}
                        </div>

                        <button type="submit"
                                className="btn btn-dark btn-lg btn-block">{forgotLoader ? 'loading....' : 'Send'}</button>
                        <div className="d-flex justify-content-between my-2">
                            <p className="">
                                <Link to="/login">Back to Login?</Link>

                            </p>
                        </div>

                    </form>
                </div>
            </div>
        </Fragment>
    );
};


const mapStateToProps = state => ({
    forgot: state.auth.forgot,
    forgotLoader: state.auth.forgotLoader
});

export default connect(mapStateToProps, {forgotPassword})(Forgot)